import { useViewConfig } from '../../hooks/useViewConfig';
import { NO_CONTENT_WIDGET_COLLECTION } from '../../constants/viewConfig';

const NoContentPlaceholder = (props) => {
  const Component = useViewConfig(NO_CONTENT_WIDGET_COLLECTION);

  return <Component {...props} />;
};

export default NoContentPlaceholder;
